'use client';

import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, Phone, MapPin, Clock, Users, ShieldAlert, HeartPulse, GraduationCap, Sprout, Wrench, Landmark, Palette, Briefcase } from 'lucide-react';
import Footer from '@/components/Footer';


const CATEGORIAS = [
  {
    titulo: "Prefeitura",
    icone: <Building2 className="w-6 h-6" />,
    cor: "text-violet-600",
    bg: "bg-violet-100",
    contatos: [
      { name: "Prefeitura Municipal", number: "(45) 3234-8500", color: "bg-violet-600" },
    ]
  },
  {
    titulo: "Saúde",
    icone: <HeartPulse className="w-6 h-6" />,
    cor: "text-emerald-600",
    bg: "bg-emerald-100",
    contatos: [
      { name: "Recepção", number: "(45) 3234-8580", color: "bg-emerald-600" },
      { name: "Pronto Atendimento", number: "(45) 3234-8585", color: "bg-emerald-600" },
      { name: "Pronto Atendimento", number: "(45) 3234-8586", color: "bg-emerald-600" },
      { name: "Pronto Socorro", number: "(45) 3234-2008", color: "bg-emerald-600" },
      { name: "Fichário", number: "(45) 3234-2001", color: "bg-emerald-600" },
      { name: "Epidemiologia", number: "(45) 3234-2003", color: "bg-emerald-600" },
      { name: "Odontologia", number: "(45) 3234-2004", color: "bg-emerald-600" },
      { name: "Farmácia", number: "(45) 3234-2006", color: "bg-emerald-600" },
      { name: "Enfermagem", number: "(45) 3234-2009", color: "bg-emerald-600" },
      { name: "Vacina", number: "(45) 3234-2010", color: "bg-emerald-600" },
      { name: "Vigilância Sanitária", number: "(45) 3234-2011", color: "bg-emerald-600" },
      { name: "Agendamento de Carro", number: "(45) 3234-2012", color: "bg-emerald-600" },
      { name: "Agendamentos", number: "(45) 3234-2015", color: "bg-emerald-600" },
      { name: "UBS Ibiracema", number: "(45) 3234-8588", color: "bg-emerald-600" },
      { name: "UBS Jardim Catanduvas", number: "(45) 3234-8587", color: "bg-emerald-600" },
      { name: "UBS Vila Santa Cruz", number: "(45) 3234-8589", color: "bg-emerald-600" },
    ]
  },
  {
    titulo: "Educação",
    icone: <GraduationCap className="w-6 h-6" />,
    cor: "text-blue-600",
    bg: "bg-blue-100",
    contatos: [
      { name: "Secretaria de Educação", number: "(45) 3234-8570", color: "bg-blue-600" },
      { name: "Coordenação", number: "(45) 3234-8571", color: "bg-blue-600" },
      { name: "CMEI", number: "(45) 3234-8575", color: "bg-blue-600" },
      { name: "Escola Maria Mayer", number: "(45) 3234-8574", color: "bg-blue-600" },
      { name: "Escola Frei Henrique", number: "(45) 3234-8577", color: "bg-blue-600" },
      { name: "Escola Prof. Valentim", number: "(45) 3234-8579", color: "bg-blue-600" },
      { name: "Escola Tiradentes", number: "(45) 3234-8576", color: "bg-blue-600" },
      { name: "Escola São Marcos", number: "(45) 3234-8578", color: "bg-blue-600" },
      { name: "Ginásio de Esportes", number: "(45) 3234-8569", color: "bg-blue-600" },
    ]
  },
  {
    titulo: "Assistência Social",
    icone: <Users className="w-6 h-6" />,
    cor: "text-purple-600",
    bg: "bg-purple-100",
    contatos: [
      { name: "Secretaria de Assistência", number: "(45) 3234-8560", color: "bg-purple-600" },
      { name: "CRAS", number: "(45) 3234-8562", color: "bg-purple-600" },
      { name: "Conselho Tutelar", number: "(45) 98822-1724", color: "bg-purple-600" },
      { name: "APMIF", number: "(45) 3234-8566", color: "bg-purple-600" },
      { name: "Asilo", number: "(45) 3234-8564", color: "bg-purple-600" },
    ]
  },
  {
    titulo: "Agricultura e Meio Ambiente",
    icone: <Sprout className="w-6 h-6" />,
    cor: "text-green-700",
    bg: "bg-green-100",
    contatos: [
      { name: "Secretaria de Agricultura", number: "(45) 3234-8559", color: "bg-green-700" },
    ]
  },
  {
    titulo: "Viação e Obras",
    icone: <Wrench className="w-6 h-6" />,
    cor: "text-slate-700",
    bg: "bg-slate-100",
    contatos: [
      { name: "Pátio de Máquinas", number: "(45) 3234-8595", color: "bg-slate-700" },
    ]
  },
  {
    titulo: "TRABALHO, INDÚSTRIA E COMÉRCIO",
    icone: <Briefcase className="w-6 h-6" />,
    cor: "text-indigo-600",
    bg: "bg-indigo-100",
    contatos: [
      { name: "Recepção", number: "(45) 3234-8535", color: "bg-indigo-600" },
    ]
  },
  {
    titulo: "Cultura",
    icone: <Palette className="w-6 h-6" />,
    cor: "text-orange-600",
    bg: "bg-orange-100",
    contatos: [
      { name: "Memorial", number: "(45) 3234-8590", color: "bg-orange-600" },
    ]
  },
];

export default function AdmMunicipalPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-blue-200 selection:text-blue-900">
      {/* Header */}
      <header className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center space-y-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 px-6 py-3 rounded-2xl text-white font-black uppercase tracking-tighter italic transition-all hover:-translate-x-1 active:scale-95 mb-8 group shadow-lg"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Voltar para o Início
          </Link>
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase italic">
            ADM Municipal <br className="md:hidden" />
            <span className="text-blue-200">Catanduvas PR</span>
          </h1>
          <p className="text-blue-100 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Telefones e contatos diretos de todas as secretarias e departamentos da prefeitura.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 -mt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-slate-100">
          <div className="flex items-center gap-3 mb-12">
            <div className="bg-blue-100 p-3 rounded-2xl">
              <Phone className="w-8 h-8 text-blue-600" />
            </div>
            <div>
              <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic">Telefones Úteis</h2>
              <p className="text-slate-500 font-bold text-sm">Toque no número para realizar a ligação</p>
            </div>
          </div>

          <div className="space-y-16">
            {CATEGORIAS.map((cat, idx) => (
              <section key={idx} className="space-y-6">
                <div className="flex items-center gap-3 border-b-2 border-slate-100 pb-4">
                  <div className={`${cat.bg} ${cat.cor} p-2 rounded-xl`}>
                    {cat.icone}
                  </div>
                  <h3 className="text-xl font-black text-slate-800 uppercase tracking-tighter italic">{cat.titulo}</h3>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {cat.contatos.map((dept, i) => (
                    <a 
                      key={i}
                      href={`tel:${dept.number.replace(/\D/g, '')}`}
                      className={`group flex items-center p-5 rounded-3xl text-white transition-all hover:scale-[1.02] active:scale-95 shadow-md ${dept.color} overflow-hidden relative`}
                    >
                      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-20 h-20 bg-white/10 rounded-full blur-xl group-hover:bg-white/20 transition-colors"></div>
                      <div className="bg-white/20 p-3 rounded-xl mr-4 backdrop-blur-sm relative z-10">
                        <Phone className="w-5 h-5" />
                      </div>
                      <div className="relative z-10 min-w-0 flex-1">
                        <p className="text-[10px] font-bold uppercase tracking-widest opacity-90 leading-none mb-1 truncate">{dept.name}</p>
                        <p className="text-xl font-bold tracking-tighter italic whitespace-nowrap">{dept.number}</p>
                      </div>
                    </a>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-20 p-8 bg-slate-50 rounded-[2rem] border border-slate-200 space-y-4">
            <h3 className="text-xl font-black text-slate-800 uppercase tracking-tighter italic flex items-center gap-2">
              <Clock className="w-6 h-6 text-blue-600" />
              Horário de Atendimento
            </h3>
            <div className="space-y-2 text-slate-600 font-medium">
              <p className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Segunda a Sexta-feira
              </p>
              <p className="flex items-center gap-3">
                <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                Das 08:00 às 12:00 e das 13:00 às 17:00
              </p>
            </div>
            <div className="pt-4 border-t border-slate-200">
              <p className="text-sm text-slate-400 italic">
                * Alguns departamentos podem ter horários diferenciados. Em caso de emergência, utilize os números 190 (PM) ou 192 (SAMU).
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

